/** Max wait for the GIS popup to complete (ms). 60 s covers slow networks without long silent waits. */
export const GOOGLE_SIGN_IN_TIMEOUT_MS = 60000;

export const GOOGLE_SIGN_IN_FAILED_MSG = 'Google sign-in failed. Please try again.';

export const SOCIAL_SIGN_IN_FAILED_MSG = 'Sign-in failed. Please try again.';

/** Vendor keys from broker login_flows API — align with SocialAuthProviderKey where applicable. */
export const APPLE_VENDOR_NAME = 'apple';
export const GOOGLE_VENDOR_NAME = 'google';
